import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from "../../../auth";
import axios from "axios";
import InputMask from 'react-input-mask';

import TableArchivos from './TableArchivos';

import { TabContent, TabPane, Nav, NavItem, NavLink, Table, Row, Button, Col, Label, Input, InputGroup, FormFeedback, Alert } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import AgregarCosto from "./AgregarCosto.js"
import CreateLTA from "../../clientes/Responsables/Create.js"
import DetailEmpresas from "../../clientes/Empresas/Detail.js"

import dateFunctions from '../../functions/dateFunctions';

var columnStyle = {
    minWidth: "125px",
    maxWidth: "125px"
}

var columnStyleObs = {
    minWidth: "200px",
    maxWidth: "200px"
}

var FieldStyle = {
    maxWidth: "100%"
}

var buttonStyle = {
    fontSize: "10px",
    padding: "1.5px 5px",
    marginTop: "-2px",
}

var vaMiddle = {
    verticalAlign: 'middle'
}

var TabHeaderStyle = {
    marginTop: '-15px',
    marginRight: '-15px',
    marginBottom: '0px',
    marginLeft: '-15px',
};

var TabHeaderBody = {
    marginTop: '0px',
    marginRight: '-15px',
    marginBottom: '-15px',
    marginLeft: '-15px',
};

class DocumentosPresupuesto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            documentosFacturas: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            documentosFacturas: [],
        })
    }

    setSelects(data) {
        
        if (data.allowed==true){
            this.setState({
                documentosFacturas: (data.documentos) ? (data.documentos)  : ([]),
            });
        }
    }

    getData() {
        const { postVariables, e_array } = this.state;

        let data = {
            'documentos': this.state.documentosFacturas.map(p => p.id ? { id: p.id } : { archivo: p.archivo }),
        };

        return data;
    }


    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].value = (input!=null && input!='') ? input : '0';
        this.setState({ costos: newCostos }, () => this.calculateCostos());
    }


    render() {
        const { action } = this.props;
        const { documentosFacturas } = this.state;
        
        var subTotal = 0;
        return (
            <ParadigmaModal
                getUrl={api.proyectos.presupuesto.CargarDocumentosPresupuesto}
                postUrl={api.proyectos.presupuesto.CargarDocumentosPresupuesto}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"Los documentos se cargaron correctamente"}
                missingIdMessage={"Debe seleccionar una fila."}
                notAllowedMessage={"El Presupuesto ya se encuentra cerrado."}
                title={"Cargar Documentos"}
                buttonTitle={"Cargar Documentos"}
                buttonIcon={"fa fa-files-o fa-lg"}
                onValidation={this.onValidation}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onPreSubmit={() => this.getData()}
                onClose={() => this.resetState()}

                fileUploader
            >

                <Row className="mt-1">
                    <Col className="col-12">
                        {/* <Label>Facturas</Label> */}
                        <TableArchivos
                            action={'EDIT'}
                            archivos={documentosFacturas}
                            // onChange={documentosFacturas => this.onChangeField('documentosFacturas', documentosFacturas)}
                            onChange={data => this.setState({'documentosFacturas': data})}
                            url={api.proyectos.presupuesto.documento.replace('$id_presupuesto', this.props.id())}
                        />
                    </Col>
                </Row>

            </ParadigmaModal>
        );
    }
}

export default DocumentosPresupuesto;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/DocumentosPresupuesto.js